import { Component, Renderer, NgZone, ViewContainerRef } from '@angular/core';
import {
  Event,
  Router,
  NavigationError,
  NavigationCancel,
  NavigationEnd,
  NavigationStart
} from '@angular/router';
import { Subscriber } from 'rxjs/Subscriber';
import { AlertService } from './shared/services/alert.service';
import { ToastsManager } from 'ng2-toastr';
import { BusyService } from './shared/services/busy.service';
import 'rxjs/add/operator/debounce';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  loading: Observable<boolean>;
  loadingObserver: Subscriber<boolean>;
private busyKey = 'app_busy';
  /**
   *
   */
  constructor(
    private router: Router,
    private ngZone: NgZone,
    private renderer: Renderer,
    private alertService: AlertService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private busyService: BusyService
  ) {
    this.loading = new Observable((observer: Subscriber<boolean>) => {
      this.loadingObserver = observer;
    })
      .debounce(() => Observable.timer(300))
      .share();

    this.toastr.setRootViewContainerRef(vcr);
    router.events.subscribe((event: Event) => {
      this._navigationInterceptor(event);
    });
    this.busyService.initHandler(this.busyKey, this.handleAppSpinner);
  }

  // Shows and hides the loading spinner during RouterEvent changes
  private _navigationInterceptor(event: Event): void {
    if (event instanceof NavigationStart) {
      this.loadingObserver.next(true);
      console.log('NavigationStart');
    }
    if (event instanceof NavigationEnd) {
      this._hideSpinner();
      setTimeout(() => {
        this.toastr.clearAllToasts();
      });

      console.log('NavigationEnd');
    }

    // Set loading state to false in both of the below events to
    // hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this._hideSpinner();
      console.log('NavigationCancel');
    }
    if (event instanceof NavigationError) {
      this._hideSpinner();
      console.log('NavigationError');
    }
  }

  private _hideSpinner(): void {
    this.loadingObserver.next(false);
  }

  private handleAppSpinner = (show: boolean) => {
    this.loadingObserver.next(show);
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/app.component.ts